import generalEn from '../locales/en.json';

export const resourcesEN = {
  general: generalEn,
};
